import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { error } from 'console';
environment
@Injectable({
  providedIn: 'root'
})
export class EnvService {

  private apiRoot = '';
  private socketRoot = '';
  private reportRoot = '';
  private client_id = '';
  private authorization_url = '';
  private logout_url = '';
  private endPoints : any;
  private ibmid_client_id : any;
  private ibmid_authorization_url : any;
  private ibmid_logout_url : any;

  constructor(private _httpClient: HttpClient) {

   }
   // loads the UI Config
 loadUIConfig() {
  console.log('Loading Ui Configurations..');
  return new Promise((resolve, reject) => {
    this._httpClient.get('/loadConfig').subscribe((res: any) => {
      console.log(res);
      this.apiRoot = res.apiRoot;
      this.authorization_url = res.authorization_url;
      this.client_id = res.client_id;
      this.logout_url = res.logout_url;
      this.reportRoot = res.reportRoot;
      this.socketRoot = res.socketRoot;
      this.endPoints = environment.endpoints;
      this.ibmid_authorization_url = res.ibmid_authorization_url;
      this.ibmid_client_id = res.ibmid_client_id;
      this.ibmid_logout_url = res.ibmid_logout_url;
    resolve(true);
  },error =>{
    console.log(error);
    this.apiRoot = environment.apiRoot;
    this.socketRoot = environment.socketRoot;
    this.reportRoot = environment.reportRoot;
    this.client_id = environment.sso.IBM.client_id;
    this.authorization_url = environment.sso.IBM.authorization_url;
    this.logout_url = environment.sso.IBM.logout_url;
    this.endPoints = environment.endpoints;
    this.ibmid_authorization_url = environment.sso.NonIBM.ibmid_authorization_url;
    this.ibmid_client_id =  environment.sso.NonIBM.ibmid_client_id;
    this.ibmid_logout_url =  environment.sso.NonIBM.ibmid_logout_url;
    resolve(true);
  });
});
}
   public getApiRoot(){
    return this.apiRoot;
   }
   public getSocketRoot(){
    return this.socketRoot;
   }
   public getReportRoot(){
    return this.reportRoot;
   }
   public getClientId(){
    return this.client_id;
   }
   public getAuthorizationUrl(){
    return this.authorization_url;
   }
   public getLogoutUrl(){
    return this.logout_url;
   }
   public getEndPoints(){
    return this.endPoints;
   }
   public getIbmid_Authorization_Url(){
    return this.ibmid_authorization_url;
   }
   public getIbmid_Client_id(){
    return this.ibmid_client_id;
   }
   public getIbmid_Logout_url(){
    return this.ibmid_logout_url;
   }
}
